export const convertSign = List => {
  const cacheObj = {}

  for (const item of List) {
    cacheObj[item.name] = item.signature
  }

  return cacheObj
}
